module.exports = __webpack_public_path__ + "img/woman-writing-cv.f74c9a96.webp";